import React from 'react';
import '../App.css';
import imagen from '../assets/1.png';
import logo from '../assets/Logo.png'

function Landing() {
  return (
    <div className="App">
      <div className="upperPage">
        {/* Fondo como div, no img */}
        <div className="backgroundImage" />

        {/* Imagen principal */}
        <img src={imagen} alt="Principal" className="upperImage" />

        {/* Enlace Demo en la esquina superior derecha */}
        <a href="demo" className="demoLink">Preview</a>
      </div>

      <div className="bottomPage">
        <div className="storeButtons">
          <button className="appleButton"></button>
          <a
  href="https://play.google.com/store/apps/details?id=com.darkcainds.chefskills"
  target="_blank"
  rel="noopener noreferrer"
>
  <button className="playStoreButton"></button>
</a>

        </div>
      </div>

      <footer className="footer">
        <div className="footer-section logo-section">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="footer-section contact-section">
          <h1 className="footer-title">Contacto</h1>
          <p className="footer-email">chefskills.app@gmail.com</p>
        </div>
        <div className="footer-section credits-section">
          <p>Desarrollado por DarkCainDS – Full-Stack • UX/UI • Infraestructura</p>
          <div className="footer-links">
            <a href="/privacy">Privacidad</a> |
            <a href="/terms">Términos</a> |
            <a href="/delete-account" className="deleteAccountLink">Eliminar Cuenta</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
